export default __webpack_public_path__ + "static/media/loading_logo_color.e5bb8619.gif";